// Core
import { Map, List } from 'immutable';
import { handleActions } from 'redux-actions';

// Instruments
import { hotActions as actions } from './actions';

const initialState = Map({
    blocks:      Map(),
    tours:       Map(),
    recommended: Map(),
});

export const hotReducer = handleActions({
    [actions.getBlockSuccess]: (state, { payload: { blockId, tours }}) => {
        return state.setIn(['blocks', blockId], tours);
    },
    [actions.getTourSuccess]: (state, { payload: { tourId, hotels }}) => {
        if (!hotels) {
            return state.setIn(['tours', tourId], null);
        }
        const hotelNotRendered = (hotel) => !state
            .get('tours')
            .some((rendered, renderedTourId) => rendered && rendered.id === hotel.id && renderedTourId !== tourId);
        const [hotel = null] = hotels.filter(hotelNotRendered);

        return state.setIn(['tours', tourId], hotel);
    },
    [actions.getToursCountriesSuccess]: (state, { payload: countries }) => {
        return state.set('countries', List(countries));
    },
    [actions.getCountryRecommendedToursSuccess]: (state, { payload: { countryId, blocks }}) => {
        return state.setIn(['recommended', countryId], blocks);
    },
}, initialState);
